import React, { useEffect } from 'react';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { ITaxCertificationRequestData } from 'types/order/title/ITaxCertificationRequest';
import { useSelector } from 'react-redux';
import { RootStore } from 'store/types';
import { getTaxCertificationAsyncAction } from 'store/order/taxCertifications/taxCertificationSlice';
import { TaxCertificationRequestPage } from '../title/TaxCertificationRequestPage';
import { useAppDispatch } from '../../../store/store';

export interface ITaxCertificationRequestComponentProps {
  orderId: string;
  taxCertificationRequest?: ITaxCertificationRequestData;
  onCreateTaxCertification: () => void;
  onCancelTaxCertification: (taxCertId: string) => void;
  createTaxCertFetchStatus: IFetchStatus;
  cancelTaxCertFetchStatus: IFetchStatus;
  cancelTaxCertificationError?: Error;
  createTaxCertificationRequestError?: Error;
}

export const TaxCertificationRequestContainer: React.FC<ITaxCertificationRequestComponentProps> = ({
  orderId,
  taxCertificationRequest,
  onCreateTaxCertification,
  onCancelTaxCertification,
  createTaxCertFetchStatus,
  cancelTaxCertFetchStatus,
  cancelTaxCertificationError,
  createTaxCertificationRequestError,
}) => {
  const dispatch = useAppDispatch();
  const taxCertificationList = useSelector((state: RootStore) => state.order.taxCertification.taxCertificationSlice);
  const hasTaxCertification = !!taxCertificationList.data.taxCertifications[0];

  useEffect(() => {
    dispatch(getTaxCertificationAsyncAction(orderId));
  }, [dispatch, orderId]);

  return (
    <TaxCertificationRequestPage
      createTaxCertFetchStatus={createTaxCertFetchStatus}
      cancelTaxCertFetchStatus={cancelTaxCertFetchStatus}
      lastTaxCertificationRequest={taxCertificationRequest}
      cancelTaxCertificationError={cancelTaxCertificationError}
      createTaxCertificationRequestError={createTaxCertificationRequestError}
      hasTaxCertification={hasTaxCertification}
      onCreateTaxCertification={onCreateTaxCertification}
      onCancelTaxCertification={onCancelTaxCertification}
    />
  );
};
